import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const Printer = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          width="25"
          height="23"
          viewBox="0 0 25 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.2304 6.28516H6.11618C4.05578 6.28516 2.3855 7.95544 2.3855 10.0158C2.3855 12.0762 4.05578 13.7465 6.11618 13.7465H18.2304C20.2908 13.7465 21.9611 12.0762 21.9611 10.0158C21.9611 7.95544 20.2908 6.28516 18.2304 6.28516Z"
            fill="url(#printer0_linear_10600_53841)"
          />
          <path
            d="M4.5 8.63073V0.699219H19.86V8.63073"
            fill="url(#printer1_linear_10600_53841)"
          />
          <path
            d="M4.85932 21.4318H2.83335C2.17203 21.4318 1.5378 21.1321 1.07017 20.5987C0.602552 20.0653 0.339844 19.3418 0.339844 18.5874V11.4763C0.339844 10.7219 0.602552 9.99839 1.07017 9.46495C1.5378 8.93152 2.17203 8.63184 2.83335 8.63184H21.8463C22.5077 8.63184 23.1419 8.93152 23.6095 9.46495C24.0771 9.99839 24.3398 10.7219 24.3398 11.4763V18.5874C24.3398 19.3418 24.0771 20.0653 23.6095 20.5987C23.1419 21.1321 22.5077 21.4318 21.8463 21.4318H19.8204"
            fill="url(#printer2_linear_10600_53841)"
          />
          <circle cx="21.4985" cy="11.7197" r="0.5" fill="#363538" />
          <path
            d="M20.162 16.1543H4.802V21.432H20.162V16.1543Z"
            fill="url(#printer3_linear_10600_53841)"
          />
          <path
            d="M5.28564 18.2018V16.1543H19.8532V18.2018"
            fill="url(#printer4_linear_10600_53841)"
          />
          <path
            d="M18.9004 22.2045C19.9953 22.2146 19.838 21.7302 19.838 21.401L18.8124 21.2559C18.364 21.5676 17.7538 22.1939 18.9004 22.2045Z"
            fill="#E2E2E2"
          />
          <defs>
            <linearGradient
              id="printer0_linear_10600_53841"
              x1="9.62748"
              y1="13.7469"
              x2="9.52888"
              y2="6.2849"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#666666" />
              <stop offset="1" stop-color="#313033" />
            </linearGradient>
            <linearGradient
              id="printer1_linear_10600_53841"
              x1="12.18"
              y1="-1.31678"
              x2="12.18"
              y2="8.63073"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#DFDFDF" />
              <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient
              id="printer2_linear_10600_53841"
              x1="12.3398"
              y1="8.63184"
              x2="12.3399"
              y2="20.5254"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#929292" />
              <stop offset="0.275218" stop-color="#EAEAEA" />
              <stop offset="1" stop-color="#999499" />
            </linearGradient>
            <linearGradient
              id="printer3_linear_10600_53841"
              x1="10.4844"
              y1="21.4322"
              x2="10.4215"
              y2="16.1539"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#666666" />
              <stop offset="1" stop-color="#313033" />
            </linearGradient>
            <linearGradient
              id="printer4_linear_10600_53841"
              x1="12.5694"
              y1="16.8584"
              x2="12.5694"
              y2="18.2018"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#F8F8F8" />
              <stop offset="1" stop-color="#D6D6D6" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default Printer;
